import { Component, AfterViewInit, OnInit, OnDestroy, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, HostListener, effect, PLATFORM_ID, Inject, ChangeDetectorRef, Renderer2, ViewChild, ElementRef, signal, computed, NgZone, ChangeDetectionStrategy } from '@angular/core';
import * as globalConstant from '../../global_constant';
import { CommonModule, isPlatformBrowser, Location, DOCUMENT } from '@angular/common';
import { Router, NavigationEnd, RouterModule } from '@angular/router';
import { filter, Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, takeUntil } from 'rxjs/operators';
import { MessageService } from 'src/app/message.service';
import { AddExperience } from 'src/app/services/AddExperience.service';
import { FindCouple } from 'src/app/services/findcouple.service';
import { LocationService } from 'src/app/services/location.service';
import { SmartSearchService, SmartSearchSuggestion } from 'src/app/services/smart-search.service';
import { SelectModule } from 'primeng/select';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { FormsModule } from '@angular/forms';
import { MainService } from 'src/app/main.service';
import { UserProfileService } from '../../services/Userprofile.service';
import { AuthdataMessageService } from 'src/app/authdata-message.service';
import { CartService } from 'src/app/services/cart.service';
import { ToastrService } from 'src/app/services/toastr.service';
import { AppStateService } from 'src/app/services/app-state.service';
import { ReferralCodeService } from 'src/app/services/ReferralCode.service';
import { KlaviyoService } from 'src/app/services/klaviyo.service';
import { LoginModal } from 'src/app/components/login-modal/login-modal';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';


/** Row in the mobile slide-in nav (link and/or nested children for multi-level menus). */
export interface MobileNavRow {
  id: string;
  label: string;
  icon?: string;
  /** Compact menu thumbnail (same image_url source as desktop mega). */
  imageUrl?: string;
  /** Use contain for logos/SVGs; cover for photo thumbs. */
  thumbFit?: 'cover' | 'contain';
  /** Extra CSS class on the nav button (e.g. static CTA rows). */
  cssClass?: string;
  link?: any[];
  children?: MobileNavRow[];
}

@Component({
  selector: 'app-top-menu',
  standalone: true,
  imports: [
    SelectModule,
    AutoCompleteModule,
    FormsModule,
    RouterModule,
    CommonModule],
  templateUrl: './top-menu.component.html',
  styleUrl: './top-menu.component.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopMenuComponent implements OnInit, OnDestroy, AfterViewInit {
  web_cdn_url: String = globalConstant.WEB_CDN_URL;
  boundResize: any;
  boundClickOutside: any;
  megamenuInitialized = false;
  experiencesMenuInitialized = false;
  activeMegaMenu: string | null = null;
  /** When true, mouseleave will not close the open desktop mega (click-to-pin) */
  megaMenuPinned = false;
  private megaCloseTimeout: any;
  private megaOpenTimeout: any;
  private readonly megaOpenDelayMs = 500;
  activeCountrySlug: string | null = null;
  activeRegionName: string | null = null;
  isNoArrowRegion: boolean = false;
  activeCategorySlug: string | null = null;
  isBrowser: boolean;
  is_mobile_view: boolean = false;
  authUser: any;
  authCheck: boolean = false;
  isLogin: boolean = false;
  locationList: any = [];
  locationAutocompleteList: any = [];
  autocomplete_location_search: string = '';
  locationListSubscription: Subscription;
  categoryList_for_gift_ideas: any = '';
  categoryList_for_experiece: any = '';
  isBoat: boolean = false;
  private menuOpen = false;
  mobileMenuOpen = false;
  /** Mobile drawer drill-down stack (supports 2–3 levels: Location regions/cities, Experience children). */
  mobileNavStack: { title: string; items: MobileNavRow[] }[] = [];
  cartDetails: any[] = [];
  getCartMessageSubscription: Subscription;
  getLogoutMessageSubscription: Subscription;
  is_cart_fill: boolean = false;
  show_card_details: any = false;
  showCountDownText: boolean = false;
  showCountDownTextPopup: boolean = false;
  tokenkey: any = '';
  isInfluencer: boolean = false;
  hasBookingType1: boolean = false;
  accountMenuOpen: boolean = false;
  couple_name: string = '';
  profile_img_url = '';
  profile_image = '';
  authDataMessageSubscription: Subscription;
  authDataMessageProfilePicSubscription: Subscription;
  showUploadProfileText: boolean = false;
  cover_image_url = '';
  showAddExpBtns: boolean = false;
  timerString: string = '';
  timerEndDate: any = "";
  timerStartDate: any = "";
  timerIntervalFunc: any;
  subscription: Subscription;
  cart_details: any = [];
  cartData: any;
  isLoading: boolean = false;
  currentURL1: any = '';
  coupleRoleID = globalConstant.WEDDING_COUPLE_ROLE_ID
  isPopupLocked: boolean = false;
  private hoverTimeout: any;
  totalAdded: any = 0;
  addExpCountSubscription: Subscription;
  wallet_balance: any = "0.00";
  @ViewChild('miniCart') miniCart!: ElementRef;
  @ViewChild('smartSearchRoot') smartSearchRoot?: ElementRef<HTMLElement>;
  @ViewChild('smartSearchRootMobile') smartSearchRootMobile?: ElementRef<HTMLElement>;
  @ViewChild('smartSearchRootMobileSub') smartSearchRootMobileSub?: ElementRef<HTMLElement>;
  @ViewChild('smartSearchRootMobileAuth') smartSearchRootMobileAuth?: ElementRef<HTMLElement>;

  /** Isolated header smart search — does not affect mega-menu / cart / map. */
  smartSearchEnabled = false;
  smartSearchQuery = '';
  smartSearchOpen = false;
  smartSearchLoading = false;
  smartSearchNoResults = false;
  smartSearchSuggestions: SmartSearchSuggestion[] = [];
  smartSearchGuidance: string[] = [];
  smartSearchExperiencesLabel = '';
  smartSearchActiveIndex = -1;
  private readonly smartSearchInput$ = new Subject<string>();
  private readonly smartSearchDestroy$ = new Subject<void>();
  private lastSmartSearchQuery = '';

  private readonly currentUrl = signal('');
  public routesToDisplayGetCode = [
    /^\/$/,
    /^\/location-region(\/[^/]+)+$/,
    /^\/spurfect-rewards(\/[^/]+)+$/,
    /^\/experience(\/[^/]+)?$/,
    /^\/gifts$/,
    /^\/gifts\/[^/]+$/,
    /^\/locations$/,
    /^\/experiences\/[^/]+$/,
    /^\/shop(\/[^/]+)?$/,
    /^\/gift-card$/
  ];


  readonly showButton = computed(() =>
    this.routesToDisplayGetCode.some(pattern => pattern.test(this.currentUrl()))
  );

  offerVisible = signal(false);
  updatedOfferVisibleSubscription$: Subscription;
  displayNewLoginBtn: boolean = true;
  bsModalRef?: BsModalRef;
  displayMaintanenceBar: boolean = true;
  announcementList = signal<any[]>([]);
  activeIndex = signal(0);
  isActive = signal(false);
  TRANSITION_MS = 900;
  HOLD_MS = 3800;
  private cycleTimer?: ReturnType<typeof setTimeout>;
  private enterTimer?: ReturnType<typeof setTimeout>;
  private previousSlideCount = 0;
  protected readonly currentSlide = computed(() => this.slides()[this.activeIndex()] ?? null);
  previousIndex = signal<number | null>(null);
  protected readonly previousSlide = computed(() => {
    const idx = this.previousIndex();
    return idx === null ? null : (this.slides()[idx] ?? null);
  });
  private exitCleanupTimer?: ReturnType<typeof setTimeout>;
  private hasRenderedOnce = false;
  selectedLocSlug: string = '';
  baseUrl = '';
  divisionImage = [
    'assets/images/northeast.png',
    'assets/images/middlewest.png',
    'assets/images/south.png',
    'assets/images/west.png'
  ];

  getDivisionImage(divisionName: string): string {
    const key = (divisionName || '').toLowerCase().trim();
    const map: Record<string, string> = {
      northeast: 'assets/images/northeast.png',
      midwest: 'assets/images/middlewest.png',
      south: 'assets/images/south.png',
      west: 'assets/images/west.png',
    };
    if (map[key]) {
      return map[key];
    }
    // Fallback: match against divisionImage filenames without false west/midwest hits
    const match = this.divisionImage.find((src) => {
      const file = (src.split('/').pop() || '').toLowerCase().replace(/\.png$/, '');
      if (key === 'midwest') {
        return file === 'midwest' || file === 'middlewest';
      }
      return file === key;
    });
    return match || this.divisionImage[0] || '';
  }

  getDivisionH1Tag(divisionName: string): string {
    const key = (divisionName || '').toLowerCase().trim();
    const map: Record<string, string> = {
      northeast: 'Cultural cities & scenic escapes',
      midwest: 'Historic town & coastlines',
      south: 'Warm destinations & adventures',
      west: 'Mountains, beaches & more',
    };
    if (map[key]) {
      return map[key];
    }
    return map[key];
  }
  private menuCatalogStarted = false;

  constructor(
    private router: Router,
    private toastr: ToastrService,
    public messageService: MessageService,
    private addexperience: AddExperience,
    private cd: ChangeDetectorRef,
    private renderer: Renderer2,
    public findCoupleService: FindCouple,
    public locationService: LocationService,
    private mainService: MainService,
    private cartService: CartService,
    private userProfileService: UserProfileService,
    private authdataMessageService: AuthdataMessageService,
    private appState: AppStateService,
    private referralCodeService: ReferralCodeService,
    private klaviyoService: KlaviyoService,
    private modalService: BsModalService,
    private ngZone: NgZone,
    private smartSearchService: SmartSearchService,
    @Inject(PLATFORM_ID) platformId: Object,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
    this.smartSearchEnabled = this.smartSearchService.enabled;
    if (this.isBrowser) {
      window.scrollTo(0, 0);
      this.baseUrl = window.location.origin;
      this.isBoat = this.isSitePerformanceBoat();
      if (window.innerWidth < 768) {
        this.is_mobile_view = true;
      } else {
        this.is_mobile_view = false;
      }

      this.currentUrl.set(this.router.url);

      // update on navigation
      this.router.events
        .pipe(filter(event => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
          this.currentUrl.set(event.urlAfterRedirects);
        });

      if (sessionStorage.getItem('selected_loc_slug')) {
        this.selectedLocSlug = sessionStorage.getItem('selected_loc_slug');
      }
    }

    this.updatedOfferVisibleSubscription$ = this.referralCodeService.displayGiftCodePopup$.subscribe(data => {
      if (data === false) {
        if (this.isBrowser) {
          if (localStorage.getItem('CoupanCode')) {
            let coupanCode = JSON.parse(localStorage.getItem('CoupanCode'));
            if (coupanCode && coupanCode?.id) {
              this.offerVisible.set(false);
            }
          }
        }
      } else {
        if (this.isBrowser) {
          if (localStorage.getItem('CoupanCode')) {
            let coupanCode = JSON.parse(localStorage.getItem('CoupanCode'));
            if (coupanCode && coupanCode?.id) {
              this.offerVisible.set(false);
            }
          } else {
            setTimeout(() => {
              this.offerVisible.set(true);
            }, 2000);
          }
        }
      }
    });

    if (this.isBrowser) {
      if (localStorage.getItem('authUser')) {
        if (localStorage.getItem('login_token')) {
          this.tokenkey = localStorage.getItem('login_token');
          this.getUserAuthDataApi();
        }
      }
    }

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {

        if (this.isBrowser) {
          this.setMobileMenuOpen(false);
          // Close desktop mega + account menu on route change
          this.closeMegaMenu();
          this.closeAccountMenu();
        }
        if (this.isBrowser) {
          if (localStorage.getItem('authUser')) {
            if (localStorage.getItem('login_token')) {
              this.authUser = localStorage.getItem('authUser');
              this.tokenkey = localStorage.getItem('login_token');
              this.isLogin = true;
              this.getUserAuthDataApi(true);
            }
          } else {
            this.isLogin = false
            this.authCheck = false
          }
        }

        if (this.router?.url?.split("/")[1]) {
          if (this.isBrowser) {
            if (this.router?.url?.split("/")[1] != 'reset-password' && localStorage.getItem('login_type')) {
              localStorage.removeItem('login_type')
            }
            if (this.router?.url?.split("/")[2]) {
              if (this.router?.url?.split("/")[3]) {
                this.currentURL1 = this.router?.url?.split("/")[3];
              } else {
                this.currentURL1 = this.router?.url?.split("/")[2];
              }
            } else {
              this.currentURL1 = this.router?.url?.split("/")[1];
            }
          }
        } else {
          this.currentURL1 = "";
        }
        this.cd.markForCheck();
      }
    });

    this.getCartMessageSubscription = this.messageService.getCartMessage().subscribe(message => {
      if (this.isBrowser) {
        if (message !== 'false') {
          try {
            this.cartDetails = (message && message !== '') ? JSON.parse(message) : [];
          } catch (e) {
            this.cartDetails = [];
          }
          this.cd.markForCheck();
        }
      }
    });

    this.addExpCountSubscription = this.messageService.getTotalMessage().subscribe(message => {
      if (message && message !== 'false') {
        if (message == 'show_first_time_popup') {
          if (this.isBrowser) {
            localStorage.removeItem('show_first_time_reg_popup');
          }
        } else {
          this.totalAdded = message.total_exp_count;
          if (typeof message.gift_add != "undefined" && message.gift_add == 1) {
            this.showCountDownText = false;
            this.authUser.gift_voucher_received = 1;
            if (this.isBrowser) {
              var updateAuthUser = JSON.parse(localStorage.getItem("authUser"));
              updateAuthUser.gift_voucher_received = 1;
              localStorage.setItem("authUser", JSON.stringify(updateAuthUser));
            }

          }
        }
        this.cd.markForCheck();
      }
    });

    this.authDataMessageProfilePicSubscription = this.authdataMessageService.getProfilePicMessage().subscribe(message => {
      if (message !== 'false') {
        this.profile_img_url = message;
        this.showUploadProfileText = false;
        this.cd.markForCheck();
      }
    });

    this.getLogoutMessageSubscription = this.messageService.getLogoutMessage().subscribe(message => {
      if (message !== 'false') {
        if (message == "1") {
          this.isLogin = true;
        }
        else {
          this.isLogin = false;
        }
        this.cd.markForCheck();
      }
    });

    this.subscription = this.cartService.getMessage().subscribe(message => {
      if (this.isBrowser) {
        if (message) {
          this.cart_details = JSON.parse(message);
          this.getCartData(message);
        } else {
          this.cart_details = [];
          this.cartDetails = [];
          this.show_card_details = false;
          this.is_cart_fill = false;
        }
        this.cd.markForCheck();
      }
    });

    this.authDataMessageSubscription = this.authdataMessageService.getAuthUserDataMessage().subscribe(message => {
      if (message && message.login_token && message.login_token.length > 0) {
        this.tokenkey = message.login_token;
      }
      this.getUserAuthDataApi();
      this.cd.markForCheck();
    });

    effect(() => {
      const total = this.slides().length; 
      if (total !== this.previousSlideCount) {
        this.previousSlideCount = total;
        this.startSlider(0);
      }
    });

  }

  getCartData(data?: any) {
    if (this.isBrowser) {
      if (localStorage.getItem('gift_box_details')) {
        localStorage.removeItem('gift_box_details');
      }
      let existingCartItems = [];
      if (data) {
        const stored = data;
        if (stored) {
          try {
            existingCartItems = JSON.parse(stored);
          } catch (e) {
            console.error("Error parsing cart_details:", e);
          }
        }
      } else if (localStorage.getItem('cart_details')) {
        const stored = localStorage.getItem('cart_details');
        if (stored) {
          try {
            existingCartItems = JSON.parse(stored);
          } catch (e) {
            console.error("Error parsing cart_details:", e);
          }
        }
      }

      const filteredCartItems = existingCartItems.filter(item => item.slug !== "gift-box");

      const stripKeys = (items: any[]) => {
        return items.map(({ voucher_for, packaging_method, send_email_to, ...rest }) => rest);
      };

      const cleanedCartDetails = stripKeys(filteredCartItems);

      if (cleanedCartDetails?.length == 0) {
        this.isLoading = false;
        this.cartDetails = [];
        // this.dataRetrieved = true;
        return;
      }

      let requestBody = {
        itemDetails: cleanedCartDetails,
        user_id: this.authUser?.id,
      };
      this.isLoading = true;

      this.cartService.getOrderOverview(requestBody).subscribe(res => {
        if (res?.response == 'success') {
          this.cartData = res?.data;

          if (this.cartData?.message && this.cartData?.message !== "Success") {
            this.toastr.errorToastr(this.cartData?.message);
          }

          if (res?.data?.final_total == 0) {
            this.isLoading = false;
            localStorage.removeItem('cart_details');
            this.cd.markForCheck();
            return;
          }
          this.cartDetails = res?.data?.cart_data?.itemDetails;
          if (this.baseUrl && (this.baseUrl == 'spurexperiences.com' || this.baseUrl == 'spurexperiences.com/'
            || this.baseUrl == 'https://spurexperiences.com/' || this.baseUrl == 'https://spurexperiences.com')) {
            this.klaviyoService.trackAddedToCart(this.cartData, this.cartDetails);
          }

          const filteredItems = res?.data?.cart_data?.itemDetails?.filter(item => item?.slug !== "gift-box") || [];
          localStorage.setItem('cart_details', JSON.stringify(filteredItems));
          this.isLoading = false;
          this.show_card_details = true;
          this.is_cart_fill = true;
          if (this.show_card_details == true) {
            if (this.isBrowser) {
              var element = document.querySelector("body");
              var htmlelement = document.querySelector("html")
              if (element) {
                element.classList.add('overflow');
              }
              if (htmlelement) {
                htmlelement.classList.add('overflow');
              }
            }

            if (this.isBrowser) {
              setTimeout(function () {
                var popupWrapElement = document.querySelector(".cartpopup-wrap");
                if (popupWrapElement) {
                  popupWrapElement.classList.add('active');
                }
              }, 100);
            }
          }
        } else {
          this.isLoading = false;
        }
        this.cd.markForCheck();
      });
    }
  }

  isSitePerformanceBoat(): boolean {
    if (this.isBrowser) {
      const userAgent = window.navigator.userAgent;
      if (userAgent.includes('GTmetrix') || userAgent.includes('Chrome-Lighthouse')) {
        return true;
      }
      return false;
    }
  }

  ngOnInit() {
    if (this.isBrowser) {
      this.initSmartSearch();
      this.scheduleMenuCatalog();
      if (localStorage.getItem('cart_details')) {
        this.cartDetails = JSON.parse(localStorage.getItem('cart_details'));
        this.is_cart_fill = true;
      }

      let masterType = { 'type': 'site-announcements' };
      this.mainService.getMasterData(masterType, this.tokenkey).subscribe(res => {
        if (res?.response == 'success') {
          this.announcementList.set(res?.data ?? []);
        }
      });
    }
  }

  protected readonly slides = computed<any[]>(() => {
    const list: any[] = [];
    const list_ = this.announcementList();

    const offer = list_.find(a => a.slug === 'coupon-code-announcements');
    if (offer && !this.authCheck && this.showButton() && this.offerVisible()) {
      list.push({ type: 'offer', data: offer });
    }

    list_
      .filter(a => a.slug !== 'coupon-code-announcements')
      .forEach(a => list.push({ type: 'announcement', data: a }));

    return list;
  });

  private startSlider(index = 0): void {
    clearTimeout(this.cycleTimer);
    clearTimeout(this.enterTimer);
    clearTimeout(this.exitCleanupTimer);

    const total = this.slides().length;
    if (!total) {
      this.previousIndex.set(null);
      this.hasRenderedOnce = false;
      return;
    }

    const safeIndex = index % total;
    const currentActive = this.activeIndex();

    // Only animate a crossfade when we're actually moving to a DIFFERENT slide.
    // With a single slide (or safeIndex === currentActive), skip the "previous" ghost entirely.
    const isRealTransition = this.hasRenderedOnce && total > 1 && safeIndex !== currentActive;

    if (isRealTransition) {
      this.previousIndex.set(currentActive);
    } else {
      this.previousIndex.set(null);
    }
    this.hasRenderedOnce = true;

    this.activeIndex.set(safeIndex);
    this.isActive.set(false);

    this.enterTimer = setTimeout(() => this.isActive.set(true), 20);

    if (isRealTransition) {
      this.exitCleanupTimer = setTimeout(
        () => this.previousIndex.set(null),
        this.TRANSITION_MS + 40
      );
    }

    const cycle = this.TRANSITION_MS + this.HOLD_MS + this.TRANSITION_MS;
    this.cycleTimer = setTimeout(() => this.startSlider(safeIndex + 1), cycle);
  }

  ngOnDestroy() {
    this.smartSearchDestroy$.next();
    this.smartSearchDestroy$.complete();
    if (this.addExpCountSubscription != undefined && this.addExpCountSubscription != null) {
      this.addExpCountSubscription.unsubscribe();
    }
    if (this.locationListSubscription) {
      this.locationListSubscription.unsubscribe();
    }
    if (this.getCartMessageSubscription != undefined && this.getCartMessageSubscription != null) {
      this.getCartMessageSubscription.unsubscribe();
    }

    if (this.authDataMessageProfilePicSubscription != undefined && this.authDataMessageProfilePicSubscription != null) {
      this.authDataMessageProfilePicSubscription.unsubscribe();
    }
    if (this.authDataMessageSubscription != undefined && this.authDataMessageSubscription != null) {
      this.authDataMessageSubscription.unsubscribe();
    }
    if (this.getLogoutMessageSubscription != undefined && this.getLogoutMessageSubscription != null) {
      this.getLogoutMessageSubscription.unsubscribe();
    }
    if (this.isBrowser) {
      this.cancelOpenMegaMenu();
      if (this.megaCloseTimeout) {
        clearTimeout(this.megaCloseTimeout);
        this.megaCloseTimeout = null;
      }
      if (this.boundResize) {
        window.removeEventListener('resize', this.boundResize);
      }
      if (this.boundClickOutside) {
        document.removeEventListener('click', this.boundClickOutside);
      }
    }
  }

  getWalletAmount() {
    if (this.authUser) {
      this.mainService.getWalletAmount(this.tokenkey).subscribe(res => {
        if (res.response == 'success') {
          this.messageService.sendNotificationCount(res);
          this.messageService.sendAmountMessage(res.data.wallet_amount);
          this.wallet_balance = parseFloat(res.data.wallet_amount).toFixed(2);
          this.totalAdded = res.data.total_exp_count;
        } else if (res.response == 'error') {
          this.wallet_balance = 0.00;
        }
        this.cd.markForCheck();
      });
    }
  }

  toggleMobileNavMenu(): void {
    this.ensureMenuCatalog();
    this.setMobileMenuOpen(!this.mobileMenuOpen);
  }

  closeMobileNavMenu(): void {
    this.setMobileMenuOpen(false);
  }

  setMobileMenuOpen(open: boolean): void {
    if (!this.isBrowser) {
      return;
    }

    this.mobileMenuOpen = open;
    if (!open) {
      this.mobileNavStack = [];
    }

    const burger = document.querySelector('.burger');
    const header = document.getElementById('header');
    const body = document.body;
    const html = document.documentElement;
    const content = document.querySelector('.body-content-wrapper');
    const menu = document.querySelector('.mobile-collapsable');
    const overlay = document.querySelector('.tm-mobile-menu-overlay');

    burger?.classList.toggle('clicked', open);
    burger?.classList.toggle('tm-burger-hidden', open);
    header?.classList.toggle('stickyScrolHead', open);
    content?.classList.toggle('show-menu', open);
    menu?.classList.toggle('menu-show', open);
    overlay?.classList.toggle('is-active', open);

    if (open) {
      body.classList.add('overflow', 'menu-opened');
      html.classList.add('overflow');
    } else {
      body.classList.remove('overflow', 'menu-opened');
      html.classList.remove('overflow');
    }

    if (header?.classList.contains('is-sticky')) {
      header.classList.add('awake');
    }

    this.cd.markForCheck();
  }



  /** True when any mobile drill-down panel is open. */
  get mobileNavOpen(): boolean {
    return this.mobileNavStack.length > 0;
  }

  get mobileNavTitle(): string {
    return this.mobileNavStack.length
      ? this.mobileNavStack[this.mobileNavStack.length - 1].title
      : '';
  }

  get mobileNavItems(): MobileNavRow[] {
    return this.mobileNavStack.length
      ? this.mobileNavStack[this.mobileNavStack.length - 1].items
      : [];
  }

  /** Back label: return to previous level or main menu. */
  get mobileNavBackLabel(): string {
    if (this.mobileNavStack.length > 1) {
      return 'Back';
    }
    return 'Back to menu';
  }

  openMobileRoot(
    key: 'location' | 'experiences' | 'gifts' | 'wedding' | 'about',
    event?: Event
  ): void {
    event?.preventDefault();
    event?.stopPropagation();
    const panel = this.buildMobileRootPanel(key);
    this.mobileNavStack = [panel];
    this.closeSmartSearch();
    this.cd.markForCheck();
  }

  /** @deprecated alias kept for safety — use openMobileRoot */
  openMobileSubmenu(
    key: 'experiences' | 'gifts' | 'wedding' | 'location' | 'about',
    event?: Event
  ): void {
    this.openMobileRoot(key as any, event);
  }

  popMobileNav(): void {
    if (!this.mobileNavStack.length) {
      return;
    }
    this.mobileNavStack = this.mobileNavStack.slice(0, -1);
    this.cd.markForCheck();
  }

  closeMobileSubmenu(): void {
    this.mobileNavStack = [];
    this.cd.markForCheck();
  }

  onMobileNavItem(item: MobileNavRow, event?: Event): void {
    event?.preventDefault();
    event?.stopPropagation();
    if (item?.children?.length) {
      this.mobileNavStack = [
        ...this.mobileNavStack,
        { title: item.label, items: item.children },
      ];
      this.closeSmartSearch();
      this.cd.markForCheck();
      return;
    }
    if (item?.link?.length) {
      this.closeMobileNavMenu();
      this.router.navigate(item.link);
    }
  }

  private buildMobileRootPanel(
    key: 'location' | 'experiences' | 'gifts' | 'wedding' | 'about'
  ): { title: string; items: MobileNavRow[] } {
    switch (key) {
      case 'location':
        return { title: 'Location', items: this.buildLocationMobileItems() };
      case 'experiences':
        return { title: 'Experiences', items: this.buildExperiencesMobileItems() };
      case 'gifts':
        return { title: 'Gifts', items: this.buildGiftsMobileItems() };
      case 'wedding':
        return { title: 'Wedding Registry', items: this.buildWeddingMobileItems() };
      case 'about':
        return { title: 'About', items: this.buildAboutMobileItems() };
      default:
        return { title: '', items: [] };
    }
  }

  private buildLocationMobileItems(): MobileNavRow[] {
    const list: any[] = Array.isArray(this.locationList) ? this.locationList : [];
    const used = new Set<string>();
    const icon = (p: string) => this.pickUniqueIcon(p, used);
    const thumb = (src?: string) => this.mobileLocationThumb(src);
    const items: MobileNavRow[] = [];

    for (const loc of list) {
      if (!loc?.slug || !loc?.name) {
        continue;
      }
      const divisions: any[] = Array.isArray(loc.divisions) ? loc.divisions : [];
      const childLocs: any[] = Array.isArray(loc.child_locations) ? loc.child_locations : [];
      let children: MobileNavRow[] = [];

      if (divisions.length) {
        // 3-level (USA): country → region → city — matches desktop mega
        children = divisions.map((div: any) => {
          const divName = String(div?.division_name || '').trim();
          const cities: any[] = Array.isArray(div?.division_data) ? div.division_data : [];
          const cityRows: MobileNavRow[] = cities
            .filter((c: any) => c?.slug && c?.name)
            .map((c: any) => ({
              id: `city-${c.slug}`,
              label: c.name,
              icon: 'pin',
              imageUrl: thumb(c.image_url),
              link: ['/location-region', loc.slug, c.slug],
            }));
          const regionChildren: MobileNavRow[] = [
            {
              id: `region-all-${divName}`,
              label: `All ${divName}`,
              icon: 'compass',
              cssClass: 'explore-btn',
              link: ['/location-region', loc.slug, divName.toLowerCase()],
            },
            ...cityRows,
          ];
          return {
            id: `div-${divName}`,
            label: divName,
            icon: 'map',
            imageUrl: this.getDivisionImage(divName) || undefined,
            cssClass: 'usa-second-level',
            link: ['/location-region', loc.slug, divName.toLowerCase()],
            children: cityRows.length ? regionChildren : undefined,
          } as MobileNavRow;
        });
      } else if (childLocs.length) {
        // 2-level only (non-USA): country → destinations — no 3rd level, matches desktop
        children = childLocs
          .filter((ch: any) => ch?.slug && ch?.name)
          .map(
            (ch: any) =>
              ({
                id: `ch-${ch.slug}`,
                label: ch.name,
                icon: 'pin',
                imageUrl: thumb(ch.image_url),
                link: ['/location-region', loc.slug, ch.slug],
              }) as MobileNavRow
          );
      }

      items.push({
        id: `loc-${loc.slug}`,
        label: loc.name,
        icon: icon('pin'),
        imageUrl: thumb(loc.image_url),
        link: ['/location-region', loc.slug],
        children: children.length
          ? [
            {
              id: `loc-all-${loc.slug}`,
              label: `Explore ${loc.name}`,
              icon: 'compass',
              cssClass: 'explore-btn',
              link: ['/location-region', loc.slug],
            },
            ...children,
          ]
          : undefined,
      });
    }

    items.push({
      id: 'locations-all',
      label: 'Explore All Locations',
      icon: icon('compass'),
      imageUrl: this.svgDataUrl('<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 2C9.87827 2 7.84344 2.84285 6.34315 4.34315C4.84285 5.84344 4 7.87827 4 10C4 11.892 4.402 13.13 5.5 14.5L12 22L18.5 14.5C19.598 13.13 20 11.892 20 10C20 7.87827 19.1571 5.84344 17.6569 4.34315C16.1566 2.84285 14.1217 2 12 2Z" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'),
      thumbFit: 'contain',
      cssClass: 'menu-button',
      link: ['/locations'],
    });
    return items;
  }

  /** Same image source as desktop mega menu, requested at a compact width. */
  private mobileLocationThumb(src?: string): string | undefined {
    const url = String(src || '').trim();
    if (!url) {
      return undefined;
    }
    if (/[?&]width=\d+/i.test(url)) {
      return url;
    }
    return url.includes('?') ? `${url}&height=60` : `${url}?height=60`;
  }

  private buildExperiencesMobileItems(): MobileNavRow[] {
    const loc = this.selectedLocSlug;
    const cats: any[] = Array.isArray(this.categoryList_for_experiece)
      ? this.categoryList_for_experiece
      : [];
    const used = new Set<string>();
    const icon = (p: string) => this.pickUniqueIcon(p, used);
    const thumb = (src?: string) => this.mobileLocationThumb(src);
    const items: MobileNavRow[] = [];

    for (const cat of cats) {
      if (!cat?.name || !cat?.slug || cat.slug === 'gift-ideas') {
        continue;
      }
      const kids: any[] = Array.isArray(cat.child_categories) ? cat.child_categories : [];
      const childRows: MobileNavRow[] = kids
        .filter((ch: any) => ch?.slug && ch?.name)
        .map((ch: any) => ({
          id: `exp-ch-${ch.slug}`,
          label: ch.name,
          icon: icon(this.submenuIconFor(ch.name || ch.slug)),
          imageUrl: thumb(ch.image_url),
          link: ['/experience', ch.slug, loc],
        }));
      items.push({
        id: `exp-${cat.slug}`,
        label: cat.name,
        icon: icon(this.submenuIconFor(cat.name || cat.slug)),
        imageUrl: thumb(cat.image_url),
        link: ['/experience', cat.slug, loc],
        children: childRows.length
          ? [
            {
              id: `exp-all-${cat.slug}`,
              label: `All ${cat.name}`,
              icon: 'compass',
              cssClass: 'explore-btn',
              link: ['/experience', cat.slug, loc],
            },
            ...childRows,
          ]
          : undefined,
      });
    }
    items.push({
      id: 'exp-athome',
      label: 'At-Home Experiences',
      icon: icon('home'),
      imageUrl: this.svgDataUrl('<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.3357 2.253C11.5187 2.09049 11.7549 2.00073 11.9997 2.00073C12.2444 2.00073 12.4807 2.09049 12.6637 2.253L21.6637 10.253C21.8518 10.4317 21.9631 10.6766 21.9741 10.9358C21.985 11.1951 21.8948 11.4484 21.7224 11.6424C21.55 11.8363 21.3089 11.9557 21.0502 11.9752C20.7914 11.9947 20.5352 11.9129 20.3357 11.747L19.9997 11.45V19C19.9997 19.5304 19.789 20.0391 19.4139 20.4142C19.0388 20.7893 18.5301 21 17.9997 21H5.99968C5.46925 21 4.96054 20.7893 4.58547 20.4142C4.2104 20.0391 3.99968 19.5304 3.99968 19V11.45L3.66368 11.747C3.46414 11.9129 3.20793 11.9947 2.94918 11.9752C2.69043 11.9557 2.4494 11.8363 2.27701 11.6424C2.10461 11.4484 2.01436 11.1951 2.02531 10.9358C2.03625 10.6766 2.14755 10.4317 2.33568 10.253L11.3357 2.253ZM5.99968 9.67V19H8.99968V14C8.99968 13.7348 9.10504 13.4804 9.29258 13.2929C9.48011 13.1054 9.73447 13 9.99968 13H13.9997C14.2649 13 14.5193 13.1054 14.7068 13.2929C14.8943 13.4804 14.9997 13.7348 14.9997 14V19H17.9997V9.671L11.9997 4.338L5.99968 9.67ZM12.9997 19V15H10.9997V19H12.9997Z" fill="#fff"/></svg>'),
      thumbFit: 'contain',
      cssClass: 'menu-button',
      link: ['/at-home-experiences'],
    });
    items.push({
      id: 'exp-all',
      label: 'View All Experiences',
      icon: icon('compass'),
      imageUrl: this.svgDataUrl('<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 4C16.0609 4 17.0783 4.42143 17.8284 5.17157C18.5786 5.92172 19 6.93913 19 8C19 9.06087 18.5786 10.0783 17.8284 10.8284C17.0783 11.5786 16.0609 12 15 12C13.9391 12 12.9217 11.5786 12.1716 10.8284C11.4214 10.0783 11 9.06087 11 8C11 6.93913 11.4214 5.92172 12.1716 5.17157C12.9217 4.42143 13.9391 4 15 4ZM15 5.9C14.443 5.9 13.9089 6.12125 13.5151 6.51508C13.1212 6.9089 12.9 7.44305 12.9 8C12.9 8.55695 13.1212 9.0911 13.5151 9.48492C13.9089 9.87875 14.443 10.1 15 10.1C15.557 10.1 16.0911 9.87875 16.4849 9.48492C16.8788 9.0911 17.1 8.55695 17.1 8C17.1 7.44305 16.8788 6.9089 16.4849 6.51508C16.0911 6.12125 15.557 5.9 15 5.9ZM15 13C17.67 13 23 14.33 23 17V20H7V17C7 14.33 12.33 13 15 13ZM15 14.9C12 14.9 8.9 16.36 8.9 17V18.1H21.1V17C21.1 16.36 17.97 14.9 15 14.9ZM5 13.28L2.5 14.77L3.18 11.96L1 10.08L3.87 9.83L5 7.19L6.11 9.83L9 10.08L6.8 11.96L7.45 14.77L5 13.28Z" fill="#fff"/></svg>'),
      thumbFit: 'contain',
      cssClass: 'menu-button',
      link: ['/experience'],
    });
    return items;
  }

  private buildGiftsMobileItems(): MobileNavRow[] {
    const loc = this.selectedLocSlug;
    const cats: any[] = Array.isArray(this.categoryList_for_gift_ideas)
      ? this.categoryList_for_gift_ideas
      : [];
    const used = new Set<string>();
    const icon = (p: string) => this.pickUniqueIcon(p, used);
    const thumb = (src?: string) => this.mobileLocationThumb(src);
    const items: MobileNavRow[] = [];
    for (const cat of cats) {
      if (!cat?.slug || cat.slug === 'gift-ideas' || !cat?.name) {
        continue;
      }
      items.push({
        id: `gift-${cat.slug}`,
        label: cat.name,
        icon: icon(this.submenuIconFor(cat.name || cat.slug)),
        imageUrl: thumb(cat.image_url),
        link: ['/gifts', cat.slug, loc],
      });
    }
    items.push({
      id: 'gift-all',
      label: 'All Gifts',
      icon: icon('gift'),
      imageUrl: this.svgDataUrl('<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22 12V20C22 20.5304 21.7893 21.0391 21.4142 21.4142C21.0391 21.7893 20.5304 22 20 22H4C3.46957 22 2.96086 21.7893 2.58579 21.4142C2.21071 21.0391 2 20.5304 2 20V12C1.73478 12 1.48043 11.8946 1.29289 11.7071C1.10536 11.5196 1 11.2652 1 11V8C1 7.46957 1.21071 6.96086 1.58579 6.58579C1.96086 6.21071 2.46957 6 3 6H6.17C6.05698 5.67873 5.99949 5.34057 6 5C6 4.20435 6.31607 3.44129 6.87868 2.87868C7.44129 2.31607 8.20435 2 9 2C10 2 10.88 2.5 11.43 3.24V3.23L12 4L12.57 3.23V3.24C13.12 2.5 14 2 15 2C15.7956 2 16.5587 2.31607 17.1213 2.87868C17.6839 3.44129 18 4.20435 18 5C18.0005 5.34057 17.943 5.67873 17.83 6H21C21.5304 6 22.0391 6.21071 22.4142 6.58579C22.7893 6.96086 23 7.46957 23 8V11C23 11.2652 22.8946 11.5196 22.7071 11.7071C22.5196 11.8946 22.2652 12 22 12ZM4 20H11V12H4V20ZM20 20V12H13V20H20ZM9 4C8.73478 4 8.48043 4.10536 8.29289 4.29289C8.10536 4.48043 8 4.73478 8 5C8 5.26522 8.10536 5.51957 8.29289 5.70711C8.48043 5.89464 8.73478 6 9 6C9.26522 6 9.51957 5.89464 9.70711 5.70711C9.89464 5.51957 10 5.26522 10 5C10 4.73478 9.89464 4.48043 9.70711 4.29289C9.51957 4.10536 9.26522 4 9 4ZM15 4C14.7348 4 14.4804 4.10536 14.2929 4.29289C14.1054 4.48043 14 4.73478 14 5C14 5.26522 14.1054 5.51957 14.2929 5.70711C14.4804 5.89464 14.7348 6 15 6C15.2652 6 15.5196 5.89464 15.7071 5.70711C15.8946 5.51957 16 5.26522 16 5C16 4.73478 15.8946 4.48043 15.7071 4.29289C15.5196 4.10536 15.2652 4 15 4ZM3 8V10H11V8H3ZM13 8V10H21V8H13Z" fill="#fff"/></svg>'),
      thumbFit: 'contain',
      cssClass: 'menu-button',
      link: ['/gifts'],
    });
    return items;
  }

  private buildWeddingMobileItems(): MobileNavRow[] {
    const icon = (svg: string) => this.svgDataUrl(svg);
    return [
      {
        id: 'w-create',
        label: 'Create a Registry',
        imageUrl: icon('<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none"><g clip-path="url(#w_create)"><path fill-rule="evenodd" clip-rule="evenodd" d="M23.0916 29.6161C23.1341 29.7073 23.1748 29.7948 23.2131 29.8793C23.4044 30.3013 23.4093 30.7342 23.2828 31.115C23.0086 31.9422 22.1147 32.5234 21.168 32.2159L2.16589 26.0422C1.21925 25.7346 0.838235 24.7392 1.10211 23.9086C1.22362 23.5263 1.48194 23.1794 1.88492 22.9499C1.96551 22.9041 2.04998 22.8572 2.13794 22.8084C3.46604 22.0716 5.58941 20.8936 7.16506 16.0447C8.44106 12.1179 12.1599 9.85073 16.0475 10.2612L16.3897 9.20795C16.6799 8.31494 17.6242 7.82107 18.4986 8.10515C19.373 8.38922 19.8466 9.34378 19.5564 10.2368L19.2142 11.29C22.6006 13.2429 24.2765 17.2627 23.0005 21.1895C21.4249 26.0384 22.4502 28.2395 23.0916 29.6161ZM14.3087 31.7752C13.7281 33.5618 11.8392 34.5488 10.0904 33.9807C8.34173 33.4125 7.39375 31.5038 7.97427 29.7173L14.3087 31.7752Z" fill="#E95225"/><path d="M38.1403 18.9804C36.5974 18.5266 33.9365 18.05 30.8978 13.0434C28.5898 9.2408 24.1302 7.78186 20.1549 9.17236L19.5359 8.15246C19.011 7.2877 17.8988 7.00303 17.0521 7.51685C16.2054 8.03067 15.9445 9.14862 16.4694 10.0134L17.0884 11.0333C14.0197 13.9174 13.2552 18.5466 15.5632 22.3492C18.6019 27.3557 17.7964 29.9359 17.4868 31.514C17.3907 32.0043 17.4922 32.459 17.7188 32.827C18.2112 33.6264 19.2917 34.0154 20.2084 33.4591L38.6095 22.2924C39.5262 21.7361 39.6803 20.5979 39.198 19.7924C38.9761 19.4214 38.6193 19.121 38.1403 18.9804V18.9804Z" fill="#E95225" stroke="white" stroke-width="1.2"/><path d="M32.2601 32.5737C33.9535 31.546 34.4761 29.3103 33.426 27.5803L27.292 31.3027C28.342 33.0328 30.5667 33.6013 32.2601 32.5737Z" fill="#E95225"/></g><defs><clipPath id="w_create"><rect width="40" height="40" fill="white"/></clipPath></defs></svg>'),
        thumbFit: 'contain',
        link: ['/registration/wedding-couple'],
      },
      {
        id: 'w-find',
        label: 'Find a Couple',
        imageUrl: icon('<svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" fill="none"><g clip-path="url(#w_find)"><path d="M21.2493 21.7479C17.2456 25.7516 10.7544 25.7516 6.75069 21.7479C2.74701 17.7442 2.74701 11.253 6.75069 7.24931C10.7544 3.24563 17.2456 3.24563 21.2493 7.24931C25.253 11.253 25.253 17.7442 21.2493 21.7479ZM21.2493 21.7479L29.3781 29.8767" stroke="#E95225" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="w_find"><rect width="38" height="38" fill="white"/></clipPath></defs></svg>'),
        thumbFit: 'contain',
        link: ['/find-couple'],
      },
      {
        id: 'w-knot',
        label: 'The Knot',
        imageUrl: 'assets/images/the-knot-Logo.png',
        thumbFit: 'contain',
        link: ['/theknot'],
      },
      {
        id: 'w-joy',
        label: 'Joy',
        imageUrl: 'assets/images/Joy-logo.png',
        thumbFit: 'contain',
        link: ['/joy'],
      },
      {
        id: 'w-zola',
        label: 'Zola',
        imageUrl: 'assets/images/zola-logo.png',
        thumbFit: 'contain',
        link: ['/zola'],
      },
      {
        id: 'w-how',
        label: 'How Registries Work',
        imageUrl: 'assets/images/menu-img01.png',
        thumbFit: 'cover',
        link: ['/howitwork'],
      },
      {
        id: 'w-why',
        label: 'Why Register with Spur',
        imageUrl: 'assets/images/menu-img02.png',
        thumbFit: 'cover',
        link: ['/wedding-registry'],
      },
    ];
  }

  private buildAboutMobileItems(): MobileNavRow[] {
    const icon = (svg: string) => this.svgDataUrl(svg);
    return [
      {
        id: 'a-spur',
        label: 'About Spur',
        imageUrl: icon('<svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33" fill="none"><circle cx="16.3922" cy="16.3922" r="15.3922" stroke="#E85325" stroke-width="2"/><path d="M13.7629 9.74268C17.0083 9.74268 19.6396 12.3734 19.6399 15.6187C19.6399 15.6704 19.6393 15.7225 19.6379 15.7739H15.9231C15.9267 15.7228 15.928 15.6707 15.928 15.6187C15.9277 14.4232 14.9585 13.4546 13.7629 13.4546C12.5676 13.4548 11.5991 14.4233 11.5989 15.6187C11.5989 15.6707 11.6002 15.7228 11.6038 15.7739H7.88892C7.88759 15.7225 7.88696 15.6704 7.88696 15.6187C7.88722 12.3736 10.5178 9.74293 13.7629 9.74268Z" fill="#E85325"/><path d="M19.3298 23.042C22.5752 23.042 25.2065 20.4113 25.2068 17.166C25.2068 17.1143 25.2062 17.0621 25.2048 17.0107H21.49C21.4936 17.0618 21.4949 17.114 21.4949 17.166C21.4946 18.3615 20.5254 19.3301 19.3298 19.3301C18.1345 19.3298 17.166 18.3613 17.1658 17.166C17.1658 17.114 17.167 17.0618 17.1707 17.0107H13.4558C13.4545 17.0621 13.4539 17.1143 13.4539 17.166C13.4541 20.4111 16.0847 23.0417 19.3298 23.042Z" fill="#E85325"/></svg>'),
        thumbFit: 'contain',
        link: ['/about'],
      },
      {
        id: 'a-spurfect',
        label: 'Spurfect Rewards',
        imageUrl: 'assets/images/step-3.png',
        thumbFit: 'contain',
        link: ['/spurfect-rewards'],
      },
      {
        id: 'a-gc',
        label: 'Gift Card',
        imageUrl: icon('<svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" fill="none"><path d="M35.0312 9.35156H33.5469V7.86719C33.5469 6.23022 32.2151 4.89844 30.5781 4.89844H2.96875C1.33178 4.89844 0 6.23022 0 7.86719V26.4219C0 27.6496 0.998836 28.6484 2.22656 28.6484H4.45312V30.875C4.45312 32.1027 5.45196 33.1016 6.67969 33.1016H17.8866C18.2965 33.1016 18.6288 32.7692 18.6288 32.3594C18.6288 31.9495 18.2965 31.6172 17.8866 31.6172H6.67969C6.27045 31.6172 5.9375 31.2842 5.9375 30.875V28.6484H31.3203C32.548 28.6484 33.5469 27.6496 33.5469 26.4219V10.8359H35.0312C35.8497 10.8359 36.5156 11.5018 36.5156 12.3203V30.875C36.5156 31.2842 36.1827 31.6172 35.7734 31.6172H24.5663C24.1565 31.6172 23.8241 31.9495 23.8241 32.3594C23.8241 32.7692 24.1565 33.1016 24.5663 33.1016H35.7734C37.0012 33.1016 38 32.1027 38 30.875V12.3203C38 10.6833 36.6682 9.35156 35.0312 9.35156ZM32.0625 7.86719V16.0312H15.7694L17.9937 15.0275C19.0559 14.5484 19.7422 13.4858 19.7422 12.3203C19.7422 10.6833 18.4104 9.35156 16.7734 9.35156C15.608 9.35156 14.5453 10.0379 14.0662 11.0999L13.0625 13.3243V6.38281H30.5781C31.3966 6.38281 32.0625 7.04863 32.0625 7.86719ZM2.96875 6.38281H11.5781V13.3243L10.5744 11.1001C10.0953 10.0379 9.03264 9.35156 7.86719 9.35156C6.23022 9.35156 4.89844 10.6833 4.89844 12.3203C4.89844 13.4858 5.58474 14.5484 6.64681 15.0275L8.87114 16.0312H1.48438V7.86719C1.48438 7.04863 2.15027 6.38281 2.96875 6.38281ZM1.48438 26.4219V17.5149H11.5035C11.1586 19.2074 9.65927 20.4844 7.86719 20.4844C7.45735 20.4844 7.125 20.8167 7.125 21.2266C7.125 21.6364 7.45735 21.9688 7.86719 21.9688C9.3198 21.9688 10.6344 21.3688 11.5781 20.4044V27.1641H2.22656C1.81732 27.1641 1.48438 26.831 1.48438 26.4219ZM31.3203 27.1641H13.0625V20.4044C14.0063 21.3687 15.3208 21.9688 16.7734 21.9688C17.1833 21.9688 17.5156 21.6364 17.5156 21.2266C17.5156 20.8167 17.1833 20.4844 16.7734 20.4844C14.9814 20.4844 13.482 19.2074 13.1372 17.5156H32.0625V26.4219C32.0625 26.831 31.7296 27.1641 31.3203 27.1641Z" fill="#E85325"/></svg>'),
        thumbFit: 'contain',
        link: ['/gift-card'],
      },
      {
        id: 'a-sendoso',
        label: 'Sendoso',
        imageUrl: 'assets/images/about-icon05.png',
        thumbFit: 'contain',
        link: ['/sendoso'],
      },
      {
        id: 'a-postal',
        label: 'Postal',
        imageUrl: 'assets/images/about-icon06.png',
        thumbFit: 'contain',
        link: ['/postal'],
      },
      {
        id: 'a-ep',
        label: 'Experience Partners',
        imageUrl: icon('<svg xmlns="http://www.w3.org/2000/svg" width="37" height="37" viewBox="0 0 37 37" fill="none"><path d="M23.1251 29.489C24.4401 29.8708 25.8026 30.0639 27.172 30.0625C29.3741 30.0657 31.5476 29.5636 33.5252 28.5948C33.5836 27.213 33.19 25.8498 32.404 24.7119C31.618 23.5739 30.4825 22.7232 29.1695 22.2887C27.8565 21.8541 26.4376 21.8595 25.128 22.3039C23.8183 22.7483 22.6892 23.6076 21.9118 24.7515M21.9118 24.7515C20.862 22.8382 19.2054 21.3288 17.203 20.4611C15.2006 19.5935 12.9664 19.4169 10.8526 19.9593C8.73882 20.5017 6.86566 21.7323 5.52847 23.4569C4.19127 25.1815 3.4661 27.3021 3.46729 29.4844L3.46883 29.6524C6.33941 31.3806 9.70179 32.375 13.2954 32.375C16.7589 32.3808 20.1581 31.4394 23.1251 29.6524V29.489V29.4844C23.1251 27.7685 22.6842 26.1544 21.9118 24.7515ZM18.5001 9.82812C18.5001 11.2081 17.9519 12.5315 16.9761 13.5073C16.0003 14.4831 14.6769 15.0312 13.297 15.0312C11.917 15.0312 10.5936 14.4831 9.61779 13.5073C8.64201 12.5315 8.09383 11.2081 8.09383 9.82812C8.09383 8.44817 8.64201 7.12474 9.61779 6.14896C10.5936 5.17318 11.917 4.625 13.297 4.625C14.6769 4.625 16.0003 5.17318 16.9761 6.14896C17.9519 7.12474 18.5001 8.44817 18.5001 9.82812ZM31.2188 13.2969C31.2188 14.3702 30.7925 15.3995 30.0335 16.1584C29.2746 16.9174 28.2452 17.3437 27.172 17.3437C26.0987 17.3437 25.0693 16.9174 24.3104 16.1584C23.5514 15.3995 23.1251 14.3702 23.1251 13.2969C23.1251 12.2236 23.5514 11.1942 24.3104 10.4353C25.0693 9.67637 26.0987 9.25 27.172 9.25C28.2452 9.25 29.2746 9.67637 30.0335 10.4353C30.7925 11.1942 31.2188 12.2236 31.2188 13.2969Z" stroke="#E85325" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'),
        thumbFit: 'contain',
        link: ['/provider/ep-providers/newregistration'],
      },
      {
        id: 'a-inf',
        label: 'Influencers',
        imageUrl: icon('<svg xmlns="http://www.w3.org/2000/svg" width="39" height="39" viewBox="0 0 39 39" fill="none"><path d="M15.9461 25.844L14.625 30.4688L13.3039 25.844C12.9624 24.6494 12.3222 23.5615 11.4437 22.683C10.5651 21.8044 9.47723 21.1642 8.28263 20.8228L3.65625 19.5L8.281 18.1789C9.4756 17.8374 10.5635 17.1972 11.442 16.3187C12.3206 15.4401 12.9608 14.3522 13.3022 13.1576L14.625 8.53125L15.9461 13.156C16.2876 14.3506 16.9278 15.4385 17.8063 16.317C18.6849 17.1956 19.7728 17.8358 20.9674 18.1772L25.5938 19.5L20.969 20.8211C19.7744 21.1626 18.6865 21.8028 17.808 22.6813C16.9294 23.5599 16.2892 24.6478 15.9478 25.8424L15.9461 25.844ZM29.6709 14.1619L29.25 15.8438L28.8291 14.1619C28.5882 13.1976 28.0898 12.3169 27.3871 11.6139C26.6844 10.911 25.8039 10.4122 24.8398 10.1709L23.1562 9.75L24.8398 9.32913C25.8039 9.08782 26.6844 8.58903 27.3871 7.88608C28.0898 7.18312 28.5882 6.30242 28.8291 5.33813L29.25 3.65625L29.6709 5.33813C29.9119 6.30262 30.4106 7.18346 31.1136 7.88643C31.8165 8.58941 32.6974 9.08808 33.6619 9.32913L35.3438 9.75L33.6619 10.1709C32.6974 10.4119 31.8165 10.9106 31.1136 11.6136C30.4106 12.3165 29.9119 13.1974 29.6709 14.1619ZM27.4527 33.4214L26.8125 35.3438L26.1723 33.4214C25.9928 32.8829 25.6904 32.3936 25.289 31.9923C24.8876 31.5909 24.3983 31.2885 23.8599 31.109L21.9375 30.4688L23.8599 29.8285C24.3983 29.649 24.8876 29.3466 25.289 28.9452C25.6904 28.5439 25.9928 28.0546 26.1723 27.5161L26.8125 25.5938L27.4527 27.5161C27.6322 28.0546 27.9346 28.5439 28.336 28.9452C28.7374 29.3466 29.2266 29.649 29.7651 29.8285L31.6875 30.4688L29.7651 31.109C29.2266 31.2885 28.7374 31.5909 28.336 31.9923C27.9346 32.3936 27.6322 32.8829 27.4527 33.4214Z" stroke="#E85325" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>'),
        thumbFit: 'contain',
        link: ['/influencers'],
      },

      {
        id: 'a-charity',
        label: 'Charity',
        imageUrl: icon('<svg xmlns="http://www.w3.org/2000/svg" width="34" height="33" viewBox="0 0 34 33" fill="none"><path d="M31.1591 10.6599H25.1027C25.3477 9.89169 25.4798 9.07577 25.4798 8.23047C25.4798 3.6922 21.6758 0 17 0C12.3241 0 8.52008 3.6922 8.52008 8.23047C8.52008 9.07577 8.65223 9.89169 8.89727 10.6599H2.84082C2.29071 10.6599 1.84473 11.0928 1.84473 11.6267V32.0332C1.84473 32.5671 2.29071 33 2.84082 33H31.1591C31.7092 33 32.1552 32.5671 32.1552 32.0332V11.6267C32.1552 11.0928 31.7092 10.6599 31.1591 10.6599ZM17 1.93359C20.5773 1.93359 23.4877 4.75838 23.4877 8.23047C23.4877 11.7026 20.5773 14.5274 17 14.5274C13.4226 14.5274 10.5123 11.7026 10.5123 8.23054C10.5123 4.75845 13.4226 1.93359 17 1.93359ZM30.163 31.0664H3.83691V12.5935H9.81288C10.2844 13.3226 10.8703 13.9751 11.546 14.5273H8.0812C7.53109 14.5273 7.08511 14.9602 7.08511 15.4941C7.08511 16.0281 7.53109 16.4609 8.0812 16.4609H25.9189C26.469 16.4609 26.9149 16.0281 26.9149 15.4941C26.9149 14.9602 26.469 14.5273 25.9189 14.5273H22.454C23.1298 13.9751 23.7156 13.3226 24.1872 12.5935H30.1631V31.0664H30.163Z" fill="#E85325"/><path d="M16.9999 19.5413C15.5717 18.296 13.3654 18.3398 11.992 19.6729C10.5686 21.0544 10.5683 23.2907 11.992 24.6723L16.2956 28.8494C16.685 29.2273 17.3156 29.2267 17.7043 28.8494L22.008 24.6724C23.4281 23.294 23.4281 21.0513 22.008 19.6729C20.6314 18.3368 18.4301 18.2927 16.9999 19.5413ZM20.5993 23.3052L16.9999 26.7986L13.4006 23.3051C12.7557 22.6793 12.7557 21.6662 13.4006 21.0402C14.0439 20.4158 15.0908 20.4158 15.7342 21.0402L16.2956 21.5851C16.6845 21.9626 17.3152 21.9626 17.7042 21.5851L18.2656 21.0402C18.9104 20.4143 19.9543 20.4143 20.5992 21.0402C21.2426 21.6647 21.2426 22.6807 20.5993 23.3052Z" fill="#E85325"/></svg>'),
        thumbFit: 'contain',
        link: ['/charities'],
      },
      // {
      //   id: 'a-ally',
      //   label: 'Ally Bank',
      //   imageUrl: 'assets/images/allybank.png',
      //   thumbFit: 'contain',
      //   link: ['/ally-bank'],
      // },
      {
        id: 'a-blog',
        label: 'Blog',
        imageUrl: icon('<svg xmlns="http://www.w3.org/2000/svg" width="35" height="34" viewBox="0 0 35 34" fill="none"><path d="M18.3204 27.964H8.8616C9.24988 27.3531 9.47191 26.5902 9.47191 25.8709V8.77631C9.47191 7.26543 10.7385 6.03612 12.2949 6.03612H25.0371C26.5924 6.03612 27.8589 7.26543 27.8589 8.77631V15.0663C27.8589 15.5944 28.2997 16.0226 28.8433 16.0226C29.3869 16.0226 29.8277 15.5944 29.8277 15.0663V8.77631C29.8277 6.21037 27.6785 4.12256 25.0371 4.12256H12.2938C9.65129 4.12256 7.50316 6.21037 7.50316 8.77631V18.3547H6.00363C3.36113 18.3547 1.21191 20.4436 1.21191 23.0106V25.8677C1.21191 28.0639 3.04176 29.851 5.30254 29.8712C5.31457 29.8712 5.32551 29.8776 5.33754 29.8776H18.3204C18.8639 29.8776 19.3047 29.4494 19.3047 28.9213C19.3047 28.3932 18.8639 27.964 18.3204 27.964ZM3.18066 25.8677V23.0106C3.18066 21.4976 4.44723 20.2683 6.00363 20.2683H7.50316V25.8496C7.50316 25.8549 7.49988 25.8592 7.49988 25.8656C7.49988 27.0226 6.53082 27.9629 5.33754 27.9629C4.14863 27.9608 3.18066 27.0226 3.18066 25.8677Z" fill="#E85325"/><path d="M24.0077 11.7671H13.3262C12.7826 11.7671 12.3418 12.1953 12.3418 12.7233C12.3418 13.2514 12.7826 13.6796 13.3262 13.6796H24.0077C24.5513 13.6796 24.9921 13.2514 24.9921 12.7233C24.9921 12.1953 24.5513 11.7671 24.0077 11.7671Z" fill="#E85325"/><path d="M24.0077 16.0439H13.3262C12.7826 16.0439 12.3418 16.4721 12.3418 17.0002C12.3418 17.5283 12.7826 17.9564 13.3262 17.9564H24.0077C24.5513 17.9564 24.9921 17.5283 24.9921 17.0002C24.9921 16.4721 24.5513 16.0439 24.0077 16.0439Z" fill="#E85325"/><path d="M32.9154 18.3386C31.7528 17.2102 29.8628 17.2102 28.7023 18.3375L21.9637 24.8825C21.7143 25.1259 21.5524 25.434 21.4934 25.7708L21.1237 27.8937C21.0329 28.4185 21.2101 28.9562 21.5973 29.3323C21.9167 29.6436 22.3509 29.8147 22.7971 29.8147C22.8901 29.8147 22.9842 29.8062 23.0782 29.7924L25.2624 29.4332C25.6124 29.3759 25.9296 29.2175 26.179 28.9742L32.9154 22.4303C34.077 21.303 34.077 19.4659 32.9154 18.3386ZM24.8501 27.5611L23.1296 27.8437L23.4206 26.1735L28.0285 21.6982L29.4581 23.0869L24.8501 27.5611Z" fill="#E85325"/></svg>'),
        thumbFit: 'contain',
        link: ['/blogs'],
      },

      {
        id: 'a-claim',
        label: 'Claim a Voucher',
        imageUrl: icon('<svg xmlns="http://www.w3.org/2000/svg" width="35" height="36" viewBox="0 0 35 36" fill="none"><path d="M33.0053 11.7474H14.7653L19.9387 10.3215C20.1935 10.2512 20.3925 10.0465 20.4608 9.78443C20.5291 9.52231 20.4563 9.24277 20.2697 9.05081L13.8173 2.41388C13.6309 2.22207 13.3592 2.14706 13.1041 2.21729C12.8494 2.2876 12.6504 2.49228 12.582 2.75432L10.243 11.7329L7.90411 2.75439C7.83576 2.49235 7.63676 2.28767 7.382 2.21737C7.12696 2.14706 6.85525 2.22207 6.66877 2.41395L0.216262 9.05074C0.0297795 9.24255 -0.0430698 9.52224 0.0251385 9.78435C0.0934874 10.0464 0.292487 10.2511 0.547248 10.3214L5.72166 11.7474H5.08992C3.99015 11.7474 3.09543 12.6677 3.09543 13.7988V31.7567C3.09543 32.8879 3.99022 33.8082 5.08992 33.8082H33.0053C34.1052 33.8082 35 32.8878 35 31.7567V13.7987C35 12.6677 34.1052 11.7474 33.0053 11.7474Z" fill="#E85325"/></svg>'),
        thumbFit: 'contain',
        link: ['/claim-voucher'],
      },

      {
        id: 'a-faq',
        label: 'FAQs',
        imageUrl: icon('<svg xmlns="http://www.w3.org/2000/svg" width="31" height="30" viewBox="0 0 31 30" fill="none"><path d="M11.9918 8.06689C13.8459 6.48668 16.8543 6.48668 18.7083 8.06689C20.564 9.6471 20.564 12.2093 18.7083 13.7896C18.3869 14.0655 18.0275 14.2921 17.6475 14.471C16.4679 15.0275 15.3517 16.0111 15.3517 17.2876V18.4438M29.6001 14.9751C29.6001 16.7972 29.2315 18.6014 28.5154 20.2848C27.7993 21.9682 26.7496 23.4978 25.4264 24.7862C24.1031 26.0746 22.5322 27.0966 20.8033 27.7939C19.0744 28.4912 17.2214 28.8501 15.3501 28.8501C13.4788 28.8501 11.6257 28.4912 9.89686 27.7939C8.16797 27.0966 6.59706 26.0746 5.27383 24.7862C3.95059 23.4978 2.90094 21.9682 2.18481 20.2848C1.46868 18.6014 1.1001 16.7972 1.1001 14.9751C1.1001 11.2952 2.60143 7.76606 5.27383 5.16399C7.94622 2.56192 11.5708 1.1001 15.3501 1.1001C19.1294 1.1001 22.754 2.56192 25.4264 5.16399C28.0988 7.76606 29.6001 11.2952 29.6001 14.9751ZM15.3501 23.0688H15.3628V23.0812H15.3501V23.0688Z" stroke="#E85325" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>'),
        thumbFit: 'contain',
        link: ['/faqs'],
      },

    ];
  }

  /** Encode an inline SVG for use as an <img> src (desktop mega icons). */
  private svgDataUrl(svg: string): string {
    return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
  }

  /** Preferred meaning-matched icon; falls back so no two items share one. */
  private pickUniqueIcon(preferred: string, used: Set<string>): string {
    const pool = [
      preferred,
      'spark', 'star', 'leaf', 'camera', 'music', 'book', 'map', 'pin',
      'clock', 'flame', 'drop', 'crown', 'balloon', 'diamond', 'snow',
      'animal', 'water', 'mountain', 'tours', 'wellness', 'food',
      'arts', 'family', 'heart', 'gift', 'games', 'getaway', 'fly',
      'home', 'compass', 'card', 'rings', 'search', 'info', 'briefcase', 'ticket',
    ];
    for (const key of pool) {
      if (!used.has(key)) {
        used.add(key);
        return key;
      }
    }
    used.add(preferred);
    return preferred;
  }

  private submenuIconFor(name: string): string {
    const n = String(name || '').toLowerCase();
    if (/(animal|zoo|whale|horse|dog|goat|bee|aquarium)/.test(n)) return 'animal';
    if (/(water|boat|sail|swim|kayak|surf|dive)/.test(n)) return 'water';
    if (/(winter|ski|snow|ice)/.test(n)) return 'snow';
    if (/(outdoor|adventure|hike|climb|zip|mountain)/.test(n)) return 'mountain';
    if (/(sight|tour|city|museum|binocular)/.test(n)) return 'tours';
    if (/(wellness|spa|relax|yoga|massage|health)/.test(n)) return 'wellness';
    if (/(food|drink|dining|culinary|wine|cook)/.test(n)) return 'food';
    if (/(art|craft|culture|entertain|theater|theatre|paint|glass|photo)/.test(n)) return 'arts';
    if (/(music|dance|concert)/.test(n)) return 'music';
    if (/(family|kid|child)/.test(n)) return 'family';
    if (/(romantic|romance|date|couple)/.test(n)) return 'heart';
    if (/(gift|unique)/.test(n)) return 'gift';
    if (/(game|fun|play)/.test(n)) return 'games';
    if (/(getaway|travel|trip|escape|stay)/.test(n)) return 'getaway';
    if (/(fly|flight|plane|air)/.test(n)) return 'fly';
    if (/(photo|camera)/.test(n)) return 'camera';
    if (/(book|learn|class|lesson)/.test(n)) return 'book';
    return 'spark';
  }

  ngAfterViewInit() {
    if (this.isBrowser) {
      this.ngZone.runOutsideAngular(() => {

        // Window Resize - only re-enters zone when mobile state changes
        this.boundResize = (event: any) => {
          this.navbarHeight();
          const isMobile = window.innerWidth < 768;
          if (this.is_mobile_view !== isMobile) {
            this.ngZone.run(() => {
              this.is_mobile_view = isMobile;
            });
          }
        };
        window.addEventListener('resize', this.boundResize);

        // Document click: close mini-cart, pinned mega, and account dropdown when clicking outside
        this.boundClickOutside = (event: Event) => {
          if (this.is_mobile_view) {
            return;
          }
          const target = event.target as HTMLElement;
          if (this.show_card_details) {
            const clickedInside = this.miniCart?.nativeElement?.contains(target);
            if (!clickedInside) {
              this.ngZone.run(() => {
                this.closeCart();
              });
            }
          }
          if (this.activeMegaMenu) {
            const inMegaNav = target.closest?.('.has-megamenu.tm-mega-open, .tm-mega');
            if (!inMegaNav) {
              this.ngZone.run(() => {
                this.closeMegaMenu();
              });
            }
          }
          if (this.accountMenuOpen) {
            const inAccount = target.closest?.('.tm-account-dropdown');
            if (!inAccount) {
              this.ngZone.run(() => {
                this.closeAccountMenu();
              });
            }
          }
        };
        document.addEventListener('click', this.boundClickOutside);
      });
    }
  }

  navbarHeight() {
    if (this.isBrowser) {
      if (window.innerWidth <= 991) {
        var HeadNav = document.getElementById("mobile-collapsable");
        HeadNav.style.height = window.innerHeight + "px";

        var elems = document.querySelectorAll(".dropdown-menu.collapse");
        [].forEach.call(elems, function (el) {
          el.classList.remove("dropdown-menu");
        });
      }
    }
  }

  onResize(event) {
    this.navbarHeight();
    if (event.target.innerWidth < 768) {
      this.is_mobile_view = true;
    } else {
      this.is_mobile_view = false;
    }
  }

  /** Exclusive mega-menu open — closes any other open panel */
  openMegaMenu(menu: string, pinned = false) {
    this.ensureMenuCatalog();
    this.cancelOpenMegaMenu();
    if (this.megaCloseTimeout) {
      clearTimeout(this.megaCloseTimeout);
      this.megaCloseTimeout = null;
    }
    const switching = this.activeMegaMenu !== menu;
    if (this.activeMegaMenu && switching) {
      if (this.activeMegaMenu === 'location') {
        this.clearLocationSelection();
      } else if (this.activeMegaMenu === 'experiences') {
        this.activeCategorySlug = null;
      }
    }
    this.activeMegaMenu = menu;
    // Hover opens unpinned; click opens/switches as pinned
    if (pinned) {
      this.megaMenuPinned = true;
    } else if (switching) {
      this.megaMenuPinned = false;
    }
    // Init first child only when opening / switching — keep selection while hovering same menu
    if (menu === 'location') {
      if (switching || !this.megamenuInitialized || !this.activeCountrySlug) {
        this.onLocationMouseEnter();
      }
    } else if (menu === 'experiences') {
      if (switching || !this.experiencesMenuInitialized || !this.activeCategorySlug) {
        this.onExperiencesMouseEnter();
      }
    }
    this.cd.markForCheck();
  }

  /** Hover intent: delay open so scroll/pass-through doesn't flash the mega */
  scheduleOpenMegaMenu(menu: string) {
    this.cancelCloseMegaMenu();
    // Already on this menu — keep it; no re-delay
    if (this.activeMegaMenu === menu) {
      this.cancelOpenMegaMenu();
      return;
    }
    // Switching between open megas — open immediately for smoother nav
    if (this.activeMegaMenu) {
      this.openMegaMenu(menu, false);
      return;
    }
    this.cancelOpenMegaMenu();
    this.megaOpenTimeout = setTimeout(() => {
      this.megaOpenTimeout = null;
      this.openMegaMenu(menu, false);
    }, this.megaOpenDelayMs);
  }

  cancelOpenMegaMenu() {
    if (this.megaOpenTimeout) {
      clearTimeout(this.megaOpenTimeout);
      this.megaOpenTimeout = null;
    }
  }

  onMegaNavClick(menu: string, event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.cancelOpenMegaMenu();
    // Click toggles pin: same pinned menu → close; otherwise open and pin
    if (this.activeMegaMenu === menu && this.megaMenuPinned) {
      this.closeMegaMenu();
      return;
    }
    this.openMegaMenu(menu, true);
  }

  scheduleCloseMegaMenu() {
    // Leaving cancels a pending hover-open
    this.cancelOpenMegaMenu();
    // Click-pinned menus stay open on mouse leave
    if (this.megaMenuPinned) {
      return;
    }
    if (this.megaCloseTimeout) {
      clearTimeout(this.megaCloseTimeout);
    }
    this.megaCloseTimeout = setTimeout(() => {
      this.closeMegaMenu();
      this.megaCloseTimeout = null;
    }, 120);
  }

  cancelCloseMegaMenu() {
    if (this.megaCloseTimeout) {
      clearTimeout(this.megaCloseTimeout);
      this.megaCloseTimeout = null;
    }
  }

  closeMegaMenu() {
    this.cancelOpenMegaMenu();
    if (this.megaCloseTimeout) {
      clearTimeout(this.megaCloseTimeout);
      this.megaCloseTimeout = null;
    }
    if (!this.activeMegaMenu && !this.megaMenuPinned) {
      return;
    }
    this.activeMegaMenu = null;
    this.megaMenuPinned = false;
    this.clearLocationSelection();
    this.activeCategorySlug = null;
    this.cd.markForCheck();
  }

  private clearLocationSelection() {
    this.activeCountrySlug = null;
    this.activeRegionName = null;
    this.isNoArrowRegion = false;
  }

  private selectCountryHierarchy(country: any) {
    if (!country) {
      return;
    }
    this.activeCountrySlug = country.slug;
    // US-style: divisions = 3 levels (country → region → places)
    if (country.divisions?.length) {
      this.activeRegionName = country.divisions[0].division_name.toLowerCase();
      this.isNoArrowRegion = false;
      return;
    }
    // Other parents: 2 levels only (country → destinations); no 3rd column
    if (country.child_locations?.length) {
      this.activeRegionName = country.child_locations[0].slug;
      this.isNoArrowRegion = true;
      return;
    }
    this.activeRegionName = null;
    this.isNoArrowRegion = true;
  }

  onLocationMouseEnter() {
    if (!this.megamenuInitialized) {
      this.megamenuInitialized = true;
    }
    if (this.locationList?.length) {
      this.selectCountryHierarchy(this.locationList[0]);
    }
    this.cd.markForCheck();
  }

  onCountryMouseEnter(slug: string) {
    const country = this.locationList?.find((l: any) => l.slug === slug);
    this.selectCountryHierarchy(country);
    this.cd.markForCheck();
  }

  onRegionMouseEnter(region: string, noArrow: boolean) {
    this.activeRegionName = region;
    this.isNoArrowRegion = noArrow;
    this.cd.markForCheck();
  }

  onExperiencesMouseEnter() {
    if (!this.experiencesMenuInitialized) {
      this.experiencesMenuInitialized = true;
    }
    const cats = this.categoryList_for_experiece;
    if (cats?.length) {
      const withChildren = cats.find((c: any) => c?.child_categories?.length > 0);
      this.activeCategorySlug = (withChildren || cats[0]).slug;
    }
    this.cd.markForCheck();
  }

  onCategoryMouseEnter(slug: string) {
    this.activeCategorySlug = slug;
    this.cd.markForCheck();
  }

  resetLocationActiveStates() {
    // Kept for compatibility; closing is handled by scheduleCloseMegaMenu
    this.clearLocationSelection();
    this.cd.markForCheck();
  }

  resetExperiencesActiveStates() {
    this.activeCategorySlug = null;
    this.cd.markForCheck();
  }

  /** True when gift countdown banner should show (same gates as before) */
  get showGiftCountdownBanner(): boolean {
    return !!(
      this.currentURL1 != 'step-3' &&
      this.currentURL1 != 'step-4' &&
      this.currentURL1 != 'step-5' &&
      this.coupleRoleID == this.authUser?.role_id &&
      this.authUser &&
      this.authUser.show_countdown_timer == 1 &&
      (this.showUploadProfileText == true || this.totalAdded < 5)
    );
  }

  openGiftCountdownModal(event?: Event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.isPopupLocked = true;
    this.showPopup();
    this.cd.markForCheck();
  }

  hasChildCategories(slug: string): boolean {
    const cat = this.categoryList_for_experiece?.find(c => c.slug === slug);
    return !!(cat?.child_categories && cat.child_categories.length > 0);
  }

  onSelectAutocompleteLocation(event) {
    switch (event?.value?.type) {
      case "location":
        if (event?.value?.value) {
          if (event?.value?.country_slug == null && event?.value?.state_slug == null) {
            this.router.navigate(['/continents/' + event?.value?.value]);
          } else if (event?.value?.country_slug == null && event?.value?.state_slug != null) {
            this.router.navigate(['/location-region/' + event?.value?.state_slug + '/' + event?.value?.value]);
          } else if (event?.value?.country_slug != null && event?.value?.state_slug != null) {
            this.router.navigate(['/location-region/' + event?.value?.country_slug + '/' + event?.value?.state_slug + '/' + event?.value?.value]);
          }
        }
        break;
    }
    this.autocomplete_location_search = '';
  }

  /** Location and category menus load after first paint, or as soon as a menu opens. */
  private scheduleMenuCatalog(): void {
    const start = () => this.ensureMenuCatalog();
    const idle = (window as Window & { requestIdleCallback?: (cb: () => void, opts?: { timeout: number }) => void }).requestIdleCallback;
    if (idle) {
      idle(start, { timeout: 5000 });
    } else {
      setTimeout(start, 3000);
    }
  }

  private ensureMenuCatalog(): void {
    if (!this.isBrowser || this.menuCatalogStarted) {
      return;
    }
    this.menuCatalogStarted = true;
    this.getLocationMenuList();
    const categorySlugForGiftIdeas = { category_for: 'experience', type: 'gift-ideas' };
    this.mainService.get_categories(categorySlugForGiftIdeas).subscribe(res => {
      this.categoryList_for_gift_ideas = res?.data;
      this.cd.markForCheck();
    });
    const categorySlugForExperience = { category_for: 'experience', type: 'higher-level-category' };
    this.mainService.get_categories(categorySlugForExperience).subscribe(res => {
      this.categoryList_for_experiece = res?.data;
      this.appState.setHighLevelCategoryData(res?.data);
      this.refreshSmartSearchCatalog();
      this.cd.markForCheck();
    });
  }

  getLocationMenuList() {
    this.locationListSubscription = this.addexperience.getLocationMenuList().subscribe(res => {
      this.locationList = res?.data;
      this.appState.setUserData(this.locationList);
      this.appState.setCountries(this.locationList);
      this.locationAutocompleteList = res?.locations;
      this.refreshSmartSearchCatalog();
      this.cd.markForCheck();
    });
  }

  /** ---- Header smart search (isolated) ---- */
  private initSmartSearch(): void {
    if (!this.smartSearchEnabled) {
      return;
    }
    this.smartSearchInput$
      .pipe(
        debounceTime(280),
        distinctUntilChanged(),
        switchMap((q) => {
          this.smartSearchLoading = true;
          this.cd.markForCheck();
          return this.smartSearchService.search(q);
        }),
        takeUntil(this.smartSearchDestroy$)
      )
      .subscribe({
        next: (result) => {
          this.smartSearchLoading = false;
          this.smartSearchSuggestions = result.suggestions || [];
          this.smartSearchGuidance = result.guidance || [];
          this.smartSearchExperiencesLabel = result.experiencesLabel || '';
          this.smartSearchNoResults =
            !!(result.query && result.query.length >= 4 && this.smartSearchSuggestions.length === 0);
          this.smartSearchActiveIndex = this.smartSearchSuggestions.length ? 0 : -1;
          this.smartSearchOpen =
            result.query.length >= 4 &&
            (this.smartSearchSuggestions.length > 0 || this.smartSearchNoResults);
          this.cd.markForCheck();
        },
        error: () => {
          // Never break the header if a preview request fails
          this.smartSearchLoading = false;
          this.smartSearchSuggestions = [];
          this.smartSearchNoResults = true;
          this.smartSearchGuidance = [
            'Type at least 4 letters — e.g. “Helico” for helicopter rides.',
            'Try a destination — e.g. “Florida” or “Mexico”.',
            'Try an experience type — e.g. “helicopter” or “spa”.',
            'Pick a suggestion to open that page, or browse Locations from the menu.',
          ];
          this.smartSearchOpen = true;
          this.cd.markForCheck();
        }
      });
  }

  private refreshSmartSearchCatalog(): void {
    if (!this.smartSearchEnabled) {
      return;
    }
    this.smartSearchService.registerCatalog({
      locations: this.locationList || [],
      categories: this.categoryList_for_experiece || [],
      defaultLocationSlug: this.selectedLocSlug || 'united-states',
    });
    // Re-run open query once live mega-menu data is available
    if (this.lastSmartSearchQuery.length >= 4 && this.smartSearchOpen) {
      this.smartSearchInput$.next(this.lastSmartSearchQuery);
    }
  }

  onSmartSearchInput(value: string): void {
    if (!this.smartSearchEnabled) {
      return;
    }
    const q = (value || '').trim();
    this.lastSmartSearchQuery = q;
    if (q.length < 4) {
      this.smartSearchSuggestions = [];
      this.smartSearchGuidance = [];
      this.smartSearchExperiencesLabel = '';
      this.smartSearchNoResults = false;
      this.smartSearchOpen = false;
      this.smartSearchLoading = false;
      this.smartSearchActiveIndex = -1;
      this.cd.markForCheck();
      return;
    }
    // Show orbit loader immediately while debounce + match run
    this.smartSearchLoading = true;
    this.smartSearchNoResults = false;
    this.smartSearchOpen = true;
    this.cd.markForCheck();
    this.smartSearchInput$.next(q);
  }

  onSmartSearchFocus(): void {
    if (!this.smartSearchEnabled) {
      return;
    }
    if (this.smartSearchSuggestions.length || this.smartSearchNoResults) {
      this.smartSearchOpen = true;
      this.cd.markForCheck();
    }
  }

  onSmartSearchKeydown(event: KeyboardEvent): void {
    if (!this.smartSearchEnabled) {
      return;
    }
    const key = event.key;
    if (key === 'Escape') {
      this.closeSmartSearch();
      return;
    }
    if (key === 'ArrowDown') {
      event.preventDefault();
      if (!this.smartSearchSuggestions.length) {
        return;
      }
      this.smartSearchActiveIndex =
        (this.smartSearchActiveIndex + 1) % this.smartSearchSuggestions.length;
      this.smartSearchOpen = true;
      this.cd.markForCheck();
      return;
    }
    if (key === 'ArrowUp') {
      event.preventDefault();
      if (!this.smartSearchSuggestions.length) {
        return;
      }
      this.smartSearchActiveIndex =
        (this.smartSearchActiveIndex - 1 + this.smartSearchSuggestions.length) %
        this.smartSearchSuggestions.length;
      this.smartSearchOpen = true;
      this.cd.markForCheck();
      return;
    }
    if (key === 'Enter') {
      event.preventDefault();
      this.submitSmartSearch();
    }
  }

  submitSmartSearch(): void {
    if (!this.smartSearchEnabled) {
      return;
    }
    const item =
      (this.smartSearchActiveIndex >= 0 &&
        this.smartSearchSuggestions[this.smartSearchActiveIndex]) ||
      this.smartSearchSuggestions[0];
    if (item) {
      this.selectSmartSearchSuggestion(item);
      return;
    }
    // If user hits enter before debounce finishes, run once immediately
    const q = (this.smartSearchQuery || '').trim();
    if (q.length < 2) {
      return;
    }
    this.smartSearchService.search(q).pipe(takeUntil(this.smartSearchDestroy$)).subscribe((result) => {
      if (result.primary) {
        this.selectSmartSearchSuggestion(result.primary);
      } else {
        this.smartSearchSuggestions = result.suggestions || [];
        this.smartSearchNoResults = true;
        this.smartSearchOpen = true;
        this.cd.markForCheck();
      }
    });
  }

  selectSmartSearchSuggestion(item: SmartSearchSuggestion, event?: Event): void {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    if (!item?.url) {
      return;
    }
    this.smartSearchQuery = item.title;
    this.closeSmartSearch();
    this.closeMobileNavMenu();
    this.router.navigateByUrl(item.url);
  }

  private closeSmartSearch(): void {
    this.smartSearchOpen = false;
    this.smartSearchActiveIndex = -1;
    this.cd.markForCheck();
  }

  /** Mood chips in mobile drawer — resolve to best matching experience category. */
  moodLink(mood: 'date' | 'adventure' | 'food' | 'getaway'): any[] {
    const loc = this.selectedLocSlug || 'united-states';
    const map: Record<string, string[]> = {
      date: ['date-night', 'romantic', 'romance', 'couples'],
      adventure: ['adventure', 'outdoor', 'adrenaline', 'flying'],
      food: ['food-and-drink', 'food-drink', 'food', 'culinary', 'dining'],
      getaway: ['getaways', 'getaway', 'travel', 'trips', 'escapes'],
    };
    const keys = map[mood] || [];
    const cats: any[] = Array.isArray(this.categoryList_for_experiece)
      ? this.categoryList_for_experiece
      : [];
    const giftCats: any[] = Array.isArray(this.categoryList_for_gift_ideas)
      ? this.categoryList_for_gift_ideas
      : [];

    const matchIn = (list: any[]) => {
      for (const key of keys) {
        const found = list.find((c) => {
          const slug = String(c?.slug || '').toLowerCase();
          const name = String(c?.name || '').toLowerCase();
          return slug === key || slug.includes(key) || name.includes(key.replace(/-/g, ' '));
        });
        if (found?.slug) {
          return found.slug;
        }
        for (const c of list) {
          const child = (c?.child_categories || []).find((ch: any) => {
            const slug = String(ch?.slug || '').toLowerCase();
            const name = String(ch?.name || '').toLowerCase();
            return slug === key || slug.includes(key) || name.includes(key.replace(/-/g, ' '));
          });
          if (child?.slug) {
            return child.slug;
          }
        }
      }
      return null;
    };

    const slug = matchIn(cats) || matchIn(giftCats);
    if (slug) {
      if (giftCats.some((c) => c?.slug === slug || (c?.child_categories || []).some((ch: any) => ch?.slug === slug))) {
        return ['/gifts', slug, loc];
      }
      return ['/experience', slug, loc];
    }
    if (mood === 'getaway') {
      return ['/location-region', loc];
    }
    return ['/experience'];
  }

  @HostListener('document:click', ['$event'])
  onDocumentClickSmartSearch(event: MouseEvent): void {
    if (!this.smartSearchEnabled || !this.smartSearchOpen || !this.isBrowser) {
      return;
    }
    const root = this.smartSearchRoot?.nativeElement;
    const rootMobile = this.smartSearchRootMobile?.nativeElement;
    const rootMobileSub = this.smartSearchRootMobileSub?.nativeElement;
    const rootMobileAuth = this.smartSearchRootMobileAuth?.nativeElement;
    const target = event.target as Node;
    const insideDesktop = !!(root && root.contains(target));
    const insideMobile = !!(rootMobile && rootMobile.contains(target));
    const insideMobileSub = !!(rootMobileSub && rootMobileSub.contains(target));
    const insideMobileAuth = !!(rootMobileAuth && rootMobileAuth.contains(target));
    if (!insideDesktop && !insideMobile && !insideMobileSub && !insideMobileAuth) {
      this.closeSmartSearch();
    }
  }

  autocompleteLocationSearch(event) {
    let requestBody = { 'search': event.query };
    this.locationService.locationAutocomplete(requestBody).subscribe(res => {
      if (res.response == 'success') {
        this.locationAutocompleteList = res.data;
      } else {
        this.locationAutocompleteList = [];
      }
      this.cd.markForCheck();
    });
  }

  toggleMenu() {
    const htmlElement = document.documentElement; // <html> tag

    this.menuOpen = !this.menuOpen;

    if (this.menuOpen) {
      this.renderer.addClass(htmlElement, 'scroll-off');
    } else {
      this.renderer.removeClass(htmlElement, 'scroll-off');
    }
  }

  getUserAuthDataApi(navigation = false) {
    if (!this.isBrowser) return;
    const $this = this;
    let requestBody = {};
    if (this.tokenkey != '') {
      this.userProfileService.get_auth_user_data(requestBody, this.tokenkey).subscribe(res => {
        if (res.response == "success") {
          if (res.data.gift_voucher_received == 1) {
            this.showCountDownText = false;
          }
          if (this.isBrowser) {

            localStorage.setItem('base_img_url', res.base_url);
            localStorage.setItem('authUser', JSON.stringify(res.data));
          }

          this.initializeAuthUserData();
        } else {
          this.logout();
        }
        this.cd.markForCheck();
      });
    }
  }

  initializeAuthUserData(fromNavigation = false) {
    if (this.isBrowser) {
      if (localStorage.getItem('authUser')) {
        this.authUser = JSON.parse(localStorage.getItem('authUser'));

        if (this.baseUrl && (this.baseUrl == 'spurexperiences.com' || this.baseUrl == 'spurexperiences.com/'
          || this.baseUrl == 'https://spurexperiences.com/' || this.baseUrl == 'https://spurexperiences.com')) {
          this.klaviyoService.identifyUser(this.authUser?.email, {
            $first_name: this.authUser?.first_name,
            $last_name: this.authUser?.last_name
          });
        }


        if (this.authUser?.is_influencer == 1) {
          this.isInfluencer = true;
        } else {
          this.isInfluencer = false;
        }
        this.authCheck = true;
        this.isLogin = true;
        this.showCountDownText = false;
        this.getWalletAmount();
        this.couple_name = this.authUser.first_name + ' & ' + this.authUser.partner_first_name;
        this.tokenkey = localStorage.getItem('login_token');
        this.loadEpBookingTypeFlag();

        if (this.authUser.profile_image !== '' && this.authUser.profile_image !== null && this.authUser.profile_image !== undefined) {
          this.profile_img_url = localStorage.getItem('base_img_url') + this.authUser.profile_image;
          this.showUploadProfileText = false;
        } else {
          this.showUploadProfileText = true;
          this.profile_img_url = 'assets/images/option_img.png';

        }

        if (this.authUser.cover_image !== '' && this.authUser.cover_image !== null && this.authUser.cover_image !== undefined) {
          this.cover_image_url = localStorage.getItem('base_img_url') + this.authUser.cover_image;
        } else {
          this.cover_image_url = 'assets/images/cover_image.jpg';
        }

        if ([1, 4, 5].includes(this.authUser.role_id)) {
          this.showAddExpBtns = true;
        }

        if (this.authUser.role_id == 1) {
          if (this.authUser.gift_voucher_received == 1) {
            this.showCountDownText = false;
          } else {
            this.showCountDownTimer();
          }
        }
      } else {
        this.profile_img_url = 'assets/images/option_img.png';
        this.cover_image_url = 'assets/images/cover_image.jpg';
        this.showCountDownText = false;
        this.timerEndDate = "";
        this.isLogin = false;
        this.authCheck = false;
        this.showUploadProfileText = false;
      }
    }
    this.cd.markForCheck();
  }

  showCountDownTimer() {
    if (this.authUser?.show_countdown_timer == 1) {
      const $this = this;
      var timeRemaining = this.authUser.time_remaining;
      var startTimestamp = new Date().getTime();
      var endTimestamp = Number(startTimestamp) + Number(timeRemaining);
      var diffTimestamp = Number(endTimestamp) - Number(startTimestamp);
      if (diffTimestamp > 0) {
        $this.generateCountTimer(diffTimestamp);
      }
    } else {
      this.showCountDownText = false;
      this.timerEndDate = "";
    }
  }

  minTwoDigits(n) {
    return (n < 10 ? '0' : '') + n;
  }

  generateCountTimer(diffTimestamp) {
    const $this = this;
    this.timerString = '';
    clearInterval(this.timerIntervalFunc);
    this.ngZone.runOutsideAngular(() => {
      this.timerIntervalFunc = setInterval(() => {
        if (Number(diffTimestamp) > 0) {
          var seconds = Math.floor((diffTimestamp) / (1000) % 60);
          var minutes = Math.floor((diffTimestamp) / (1000 * 60) % 60);
          var hours = Math.floor((diffTimestamp) / (1000 * 60 * 60) % 60);

          const nextTimer = $this.minTwoDigits(hours) + " : " + $this.minTwoDigits(minutes) + " : " + $this.minTwoDigits(seconds);
          if ($this.timerString !== nextTimer) {
            $this.ngZone.run(() => {
              $this.timerString = nextTimer;
              $this.cd.markForCheck();
            });
          }
        }
        diffTimestamp -= Number(1000);
      }, 1000);
    });
  }

  toggleAccountMenu(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.accountMenuOpen = !this.accountMenuOpen;
    if (this.accountMenuOpen) {
      this.closeMegaMenu();
    }
    this.cd.markForCheck();
  }

  closeAccountMenu() {
    if (!this.accountMenuOpen) {
      return;
    }
    this.accountMenuOpen = false;
    this.cd.markForCheck();
  }

  getAccountDisplayName(): string {
    if (!this.authUser) {
      return '';
    }
    const name = (this.authUser.username || '').trim();
    if (name.length > 15) {
      return name.slice(0, 15) + '...';
    }
    return name;
  }

  /** Same booking-type gate as ep-subheader Availability link.
   *  Calls get_experiences once auth (role 2/7 + token) is available. */
  private loadEpBookingTypeFlag(force = false) {
    const roleId = Number(this.authUser?.role_id);
    if (roleId !== globalConstant.EXPERIENCE_PROVIDER_ROLE_ID && roleId !== globalConstant.ALTERNATE_EXPERIENCE_PROVIDER_ROLE_ID) {
      this.hasBookingType1 = false;
      return;
    }
    if (!this.tokenkey) {
      this.hasBookingType1 = false;
      return;
    }
    this.userProfileService.get_experiences(this.tokenkey).subscribe(res => {
      if (res?.response === 'success') {
        this.hasBookingType1 = !!res.data?.some((exp: any) => exp.experience_booking_type === 1);
      } else {
        this.hasBookingType1 = false;
      }
      this.cd.markForCheck();
    });
  }

  logout() {
    this.closeAccountMenu();
    this.closeMobileNavMenu();
    if (this.isBrowser) {
      localStorage.removeItem('authUser');
      localStorage.removeItem('remember_me');
      localStorage.removeItem('profile_img_url')
      localStorage.removeItem('login_token')
      localStorage.removeItem('cart_details');
      localStorage.removeItem('gift_box_details');
    }
    this.cartDetails = [];
    this.show_card_details = false;
    this.is_cart_fill = false;
    this.authUser = "";
    this.authCheck = false;
    this.isLogin = false;
    this.hasBookingType1 = false;
    this.isInfluencer = false;
    this.showCountDownText = false;
    if (this.baseUrl && (this.baseUrl == 'spurexperiences.com' || this.baseUrl == 'spurexperiences.com/'
      || this.baseUrl == 'https://spurexperiences.com/' || this.baseUrl == 'https://spurexperiences.com')) {
      this.klaviyoService.resetIdentity();
    }
    setTimeout(() => {
      this.showCountDownText = false;
      this.router.navigate(['/login']);
    }, 1000);
  }

  showPopup(): void {
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout);
    }
    this.showCountDownText = true;
  }

  hidePopup(): void {
    this.showCountDownText = false;
    this.isPopupLocked = false;
  }

  togglePopupLock(event: Event): void {
    event.stopPropagation();
    this.isPopupLocked = !this.isPopupLocked;
    if (this.isPopupLocked) {
      this.showCountDownText = true;
    }
  }

  onMouseLeave(): void {
    if (!this.isPopupLocked) {
      this.hoverTimeout = setTimeout(() => {
        this.showCountDownText = false;
      }, 200);
    }
  }

  onPopoverEnter(): void {
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout);
    }
  }

  onPopoverLeave(): void {
    if (!this.isPopupLocked) {
      this.hoverTimeout = setTimeout(() => {
        this.showCountDownText = false;
      }, 200);
    }
  }

  onClickOutside(event: Event) {
    const target = event.target as HTMLElement;
    const clickedInside = this.miniCart?.nativeElement.contains(target);

    if (!clickedInside && !this.is_mobile_view) {
      this.closeCart();
    }
  }

  closeCart() {
    this.show_card_details = false;
    // this.show_card_details = false;
    this.removeOverflow();
  }

  isVoucherEligible(item: any): boolean {
    if (!item) return false;
    const isInstant = item.instant_book === 1;
    const isCompletePurchase = item.purchased_from === 'complete-purchase';
    const isTicket = item.type === 'ticket-purchase' || item.type === 'myticketpro-ticket-purchase';
    return !isInstant && !isCompletePurchase && !isTicket;
  }

  formatEventDate(dateStr: string | undefined): string {
    if (!dateStr) return '';

    const [year, month, day] = dateStr.split('-').map(Number);
    const date = new Date(year, month - 1, day);

    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  }

  removeOverflow() {
    if (this.isBrowser) {
      var element = document.querySelector("body")
      var htmlelement = document.querySelector("html")
      if (element) {
        element.classList.remove('overflow');
      }
      if (htmlelement) {
        htmlelement.classList.remove('overflow');
      }
    }
  }

  removeItem(product_id, index) {
    var childRemove = false;
    if (this.cartDetails[index]) {
      if (this.cartDetails[index].parent_id != "undefined" && this.cartDetails[index].parent_id > 0) {
        childRemove = true;
      }
      this.cartDetails.splice(index, 1);
    }
    if (this.cartDetails.length > 0) {
      if (!childRemove) {
        for (let j = 0; j < this.cartDetails.length; j++) {

          if (this.cartDetails[j] && this.cartDetails[j] != "undefined" && typeof this.cartDetails[j].parent_id != "undefined"
            && this.cartDetails[j].parent_id == product_id) {
            delete this.cartDetails[j];
          }
        }
        this.cartDetails = this.cartDetails.filter(function (element) {
          return element != "undefined";
        });
      }
    }
    if (this.isBrowser) {
      if (this.cartDetails.length > 0) {
        localStorage.setItem('cart_details', JSON.stringify(this.cartDetails));
      } else {
        localStorage.removeItem('cart_details')
      }
    }

    let requestBody = {
      itemDetails: this.cartDetails,
      user_id: this.authUser?.id,
    };

    this.isLoading = true;
    this.cartService.getOrderOverview(requestBody).subscribe(res => {
      if (res?.response == 'success') {
        this.cartData = res?.data;
        this.cartDetails = res?.data?.cart_data?.itemDetails;
        if (res?.data?.final_total == 0) {
          localStorage.removeItem('cart_details');
          this.isLoading = false;
          this.cd.markForCheck();
          return;
        }
        const filteredItems = res?.data?.cart_data?.itemDetails?.filter(item => item?.slug !== "gift-box") || [];
        localStorage.setItem('cart_details', JSON.stringify(filteredItems));
        if (this.isBrowser) {
          localStorage.setItem('cart_details', JSON.stringify(filteredItems));
        }
        this.isLoading = false;
      } else {
        this.isLoading = false;
      }
      this.cd.markForCheck();
    });
    if (this.isBrowser) {
      var element = document.querySelector("body");
      var htmlelement = document.querySelector("html")
      if (element) {
        element.classList.add('overflow');
      }
      if (htmlelement) {
        htmlelement.classList.add('overflow');
      }
    }

  }

  redirectToEngine() {
    if (this.isBrowser) {
      window.open('https://spurexperiences.partners.engine.com/p/create-event', '_blank')
    }
  }

  openSignUpPopup() {
    this.referralCodeService.openSignupPopup.next(true);
  }

  closeOfferPopup(): void {
    this.offerVisible.set(false);
  }

  openLoginModal() {
    this.closeMobileNavMenu();
    this.bsModalRef = this.modalService.show(LoginModal, {
      class: 'modal-dialog-centered modal-lg',
      backdrop: true,
      ignoreBackdropClick: false
    });
  }

  redirectToExp(cartItem) {
    if (cartItem) {
      this.closeCart();
      if (cartItem?.type == 'myticketpro-ticket-purchase') {
        if (cartItem?.ticketEvolutionId) {
          this.router.navigate(['/spur-seats'], { queryParams: { event_id: cartItem?.ticketEvolutionId } });
          return;
        } else {
          this.router.navigate(['/seats-details'], { queryParams: { event_id: cartItem?.productId } });
          return;
        }
      } else if (cartItem?.type == 'ticket-purchase') {
        this.router.navigate(['/spur-seats'], { queryParams: { event_id: cartItem?.event_id } });
        return;
      } else {
        if (cartItem?.slug === 'gift-certificate') {
          this.router.navigate(['/gift-card']);
          return;
        } else {
          this.router.navigate(['/experiences/' + cartItem?.slug]);
        }
      }
    }
  }

}
